'use client'

import { signal } from '@preact/signals-react'
import { Locale } from '@susu/headless-commerce/config/locale'
import { Availability } from '@susu/headless-commerce/features/configurator/domain/Availability/Availability'
import { Configurator } from '@susu/headless-commerce/features/configurator/domain/Configurator/Configurator'
import { Option } from '@susu/headless-commerce/features/configurator/domain/Option/Option'
import { Product } from '@susu/headless-commerce/features/configurator/domain/Product/Product'
import { Step } from '@susu/headless-commerce/features/configurator/domain/Step/Step'
import { SiteId } from '@susu/headless-commerce/gql/generated/graphql'

// Create dummy data for the first render using the provider. This will never
// actually be shown on the screen due to hydration.
const availability = new Availability(
  'C1199',
  0,
  '',
  true,
  true,
  false,
  false,
  false,
)
const product = new Product(
  availability,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  {
    breakpoint: '',
    srcset: '',
    url: '',
  },
  undefined,
  undefined,
  '',
  '',
  undefined,
  undefined,
  undefined,
  '',
  {
    breakpoint: '',
    srcset: '',
    url: '',
  },
  '',
  '',
  '',
  0,
  undefined,
  undefined,
  undefined,
  undefined,
  '',
  '',
)
const configurator = new Configurator(
  {
    countryCode: '',
    siteID: SiteId.Usa,
    ecommerce: {
      currencyCode: '',
    },
    languages: [],
    locale: Locale['en-us'],
    migrated: false,
    name: '',
  },
  Locale['en-us'],
  new URLSearchParams(),
  [],
  '',
  '',
  undefined,
  [],
)
const step = new Step(
  configurator,
  'jacket',
  [],
  '',
  '',
  undefined,
  undefined,
  '',
  '',
  '',
  undefined,
  '',
  [],
  {
    aspectRatio: 0,
    gravityParameter: '',
    urlTransformations: '',
  },
)
configurator.steps = [step]
const option = new Option(
  '',
  configurator,
  [],
  product,
  {},
  [],
  step,
  {
    _id: 'fakeID',
    contentfulMetadata: {
      tags: [],
      concepts: [],
    },
    sys: {
      id: 'fakeID',
      environmentId: 'master',
      spaceId: 'master',
    },
  },
  [],
)
step.options = [option]

export const configuratorJSONSignal = signal<string | undefined>('')

export const setConfiguratorJSON = (v: string) => {
  if (v !== configuratorJSONSignal.value) {
    configuratorJSONSignal.value = v
  }
}

export const configuratorSignal = signal(configurator)
